import Layout from '@/layout';

// 动态
export default {
    path: '/message',
    name: 'Message',
    component: Layout,
    redirect: '/message/index',
    hidden: true,
    meta: {
        title: '平台消息',
        icon: 'menu_bm'
    },
    children: [
        {
            path: 'index',
            name: 'MessageIndex',
            component: () => import('@/views/message/index'),
            meta: {
                breadcrumb: false,
                title: '平台消息',
                activeMenu: 'Message',
                keepAlive: true
            }
        },
        {
            path: 'detail/:id',
            name: 'MessageDetail',
            // hidden: true,
            component: () => import('@/views/message/detail'),
            meta: {
                title: '消息详情',
                activeMenu: 'Message'
            }
        }
    ]
};
